export const siteInfo = {
  name: "瓜田秘闻社",
  shortName: "瓜田",
  slogan: "圈内八卦内幕聚集地，越扒越有料",
  description:
    "瓜田秘闻社专注整理娱乐圈公开讨论的八卦内幕与小道消息，用专题深扒的方式还原事件来龙去脉，让你吃得明白、聊得尽兴。",
  email: "guanzhu@guatian-miwenshe.example.com",
  editorEmail: "editor@guatian-miwenshe.example.com",
  positioning: "面向吃瓜爱好者的娱乐八卦与内幕观察内容门户",
  principles: [
    "只整理已在公开渠道流传的讨论，不制造、不添油加醋",
    "涉及具体人物时统一使用匿名代称，保留讨论空间也尊重当事人",
    "每条内容标注来源脉络与时间线，方便读者自行判断",
    "欢迎读者纠错与补充，评论区与邮箱都随时开放",
  ],
  stats: [
    { label: "每日更新快讯", value: "40+" },
    { label: "在追专题", value: "6" },
    { label: "累计吃瓜用户", value: "128万" },
    { label: "单篇最高阅读", value: "236万" },
  ],
};